import 'babel-polyfill';
import $ from 'jquery';
import { data as hudlData, model, errorReporter } from 'hudl-base';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import g11n from 'hudl-g11n';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import loadAsyncScripts from '../../shared/async-scripts';
import { configureExploreStore } from '../../shared/configureStore';
import ExploreApp from '../../containers/ExploreApp';
import { ORIGIN_KEY, EXPLORE_ORIGIN } from '../../shared/logData';
import ContainerTypes from '../../shared/container-type';
import PersonalizationUtility from '../../utils/personalization-utility';
import promoteDynamicContent from 'utils/comscore';

window.onerror = errorReporter.sendError;

$(() => {
  const { IntlProvider } = g11n.ReactIntl;
  const i18n = {
    locale: hudlData.get('i18nLocale'),
    messages: hudlData.get('i18nMessages'),
  };

  // Assemble initial state data
  const clientData = model.get() || {};

  const { hudl: rawHudlData = {} } = hudlData.raw() || {};
  const { userId: currentUserId } = rawHudlData || {};

  const isLoggedIn = !!currentUserId;
  const isFetching = {};
  const feedItems = {};
  const recentlyViewedTeamIds = PersonalizationUtility.getRecentTeamIds();
  const discoveryTimelines = clientData.discoveryTimelines || [];
  const adTag = {
    vastTag: clientData.vastTag,
    mobileVastTag: clientData.mobileVastTag,
    preRollAdData: clientData.preRollAdData,
  };

  adTag.preRollAdData.containerType = 'Explore';

  const exploreState = {
    exploreFilters: {
      teamIds: recentlyViewedTeamIds,
    },
    exploreTabs: {
      isLoggedIn,
      isFetching,
      feedItems,
      discoveryTimelines,
      adTag,
      comScoreId: clientData.comScoreId,
    },
  };

  const exploreStore = configureExploreStore({
    explore: exploreState,
  });

  const exploreLogData = {
    [ORIGIN_KEY]: EXPLORE_ORIGIN,
    Container: ContainerTypes.Explore,
  };

  window.__hudlui_Generic && window.__hudlui_Generic.init();
  window.__hudlui_WebNav && window.__hudlui_WebNav.renderHelper();

  render(
    // eslint-disable-next-line react/jsx-props-no-spreading
    <IntlProvider {...i18n}>
      <Provider store={exploreStore}>
        <Router basename="/explore">
          <Route path="/:tab?" component={() => <ExploreApp logData={exploreLogData} />} />
        </Router>
      </Provider>
    </IntlProvider>,
    document.getElementById('explore'),
  );
  loadAsyncScripts();
  promoteDynamicContent(clientData.comScoreId);
});
